import Vue from "vue";

const getDefaultState = () => {
  return {
    profile: null,
    widgets: [],

    currentTab: null,

    isWidgetEditModeEnabled: false,
  };
};

const state = Vue.observable(getDefaultState());

const methods = {
  RESET_STATE() {
    Object.assign(state, getDefaultState());
  },

  toggleWidgetEditing() {
    state.isWidgetEditModeEnabled = !state.isWidgetEditModeEnabled;
  },

  setProfile(profile) {
    state.profile = profile;
  },

  setProfileWidgets(widgets) {
    state.widgets = widgets;
  },

  setTab(tab) {
    state.currentTab = tab;
  },
};

const ProfileStore = {
  state,
  methods,
};
export default ProfileStore;
